import { getCookies, setCookie } from '../utils/cookie';

type ShowTooltipProps = {
  toggle: () => void;
  type?: ITooltipType;
  delayToHide?: number;
};

type ShowTooltipAfterDelayProps = ShowTooltipProps & {
  delayToShow: number;
};

type ITooltipType =
  | 'address'
  | 'store'
  | 'orderStore'
  | 'ordersDetailsHelp'
  | 'ordersDetailsRate'
  | 'ordersDetailsRebuy'
  | 'ordersRate'
  | 'progressBarMinimumFreeShipping'
  | 'progressBarMinimumOrderValue'
  | 'minimumOrderValue'
  | 'checkoutLocation'
  | 'checkoutCards'
  | 'basket'
  | 'cvList'
  | 'cvFavorites'
  | 'cvPharmacyCard'
  | 'cvItemTab';

const defaultCookieValue = 'true';
const fifteenDays = 60 * 60 * 24 * 14;

export const useTooltip = () => {
  const isShowTooltipAfterInactivity = (type: ITooltipType): boolean => {
    if (typeof window === 'undefined') return false;
    const cookies = getCookies();

    const tooltipName = `fapp.tooltip.${type}`;
    const tooltipGeneralInactivity = 'fapp.tooltip.general';

    const tooltipCookie = cookies[tooltipName];

    setCookie(tooltipName, defaultCookieValue, fifteenDays);
    setCookie(tooltipGeneralInactivity, defaultCookieValue, fifteenDays);

    if (!tooltipCookie) return true;

    const isInactivity = !cookies[tooltipGeneralInactivity];

    return isInactivity;
  };

  const hideTooltip = ({
    toggle,
    delayToHide,
  }: Omit<ShowTooltipProps, 'type'>) => {
    setTimeout(() => {
      toggle();
    }, delayToHide);
  };

  const showTooltip = ({ type, toggle, delayToHide }: ShowTooltipProps) => {
    if (!!type && !isShowTooltipAfterInactivity(type)) return;

    toggle();
    if (delayToHide) hideTooltip({ toggle, delayToHide });
  };

  const showTooltipAfterDelay = ({
    type,
    toggle,
    delayToShow,
    delayToHide,
  }: ShowTooltipAfterDelayProps) => {
    if (!!type && !isShowTooltipAfterInactivity(type)) return;

    setTimeout(() => {
      toggle();
      if (delayToHide) hideTooltip({ toggle, delayToHide });
    }, delayToShow);
  };

  return { isShowTooltipAfterInactivity, showTooltip, showTooltipAfterDelay };
};
